import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// import NumberInput from "../Inputs/NumberInput";
// import TextInput from "../Inputs/TextInput";
// import TextAreaInput from "../Inputs/TextAreaInput";
// import InputSelect from "../Inputs/InputSelect";
// import UploadImgeInput from "../Inputs/UploadImgeInput";
// import DatePickerInput from "../Inputs/DatePickerInput";
// import DragAndDropFileUploaderInput from "../Inputs/DragAndDropFileUploaderInput";
// import { ContentItemExtraFieldsKeys } from "../../constants/types/componentsTypes/BuilderTypes";
// import SwitchInput from "../Inputs/SwitchInput";
// import UploadMedia from "../Inputs/UploadMedia";
// import { ContentItemRequierdKeys } from "../../constants/types/componentsTypes/BuilderTypes";
import Select from 'react-select';
// import ContentEntityTypeServices from "../../services/contentServecies/ContentEntityTypeServices";
import { TrashIcon } from '@heroicons/react/outline';
// import { ContentEntityTypesOutput } from "../../constants/types/contentSystemTypes/ContentEntityTypeTypes";
// import HasPermission from "../../util/HasPermission";
// import SetItemTemplateSelectField from "../ExtraComponents/SetItemTemplateSelectField";
// import NarratorsServices from "../../services/contentServecies/NarratorsServices";
// import InnerPageToggelButton from "../General/InnerPageToggelButton";
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
// import ColorPickerInput from "../Inputs/ColorPickerInput";
// import {
//   FormBuilderProps,
//   Row,
// } from "../../constants/types/componentsTypes/BuilderTypes";
// import { FieldType } from "../../constants/types/componentsTypes/BuilderTypes";
// import TinyMCEInput from "../Inputs/TinyMCEInput";
// import Card from "../DataDisplay/Card";
// import Button from "../General/Button";
// import { formsMetadata } from "../../constants/constants";
// import CallBackSelectore from "../Inputs/CallBackSelectore";
// import FormBuilderServices from "../../services/FormBuilderServices";
// import InputLabel from "../Inputs/InputLabel";
import { PlusIcon } from '@heroicons/react/outline';
import showdown from 'showdown';
import { Content } from '@wajeez-web/core/api-base';
import { useEffectCancelled } from '@wajeez-web/components/helpers';
import {
  Button,
  CallBackSelector,
  CallBackSelectorWithOptions,
  Card,
  ColorPickerInput,
  DatePickerInput,
  DragAndDropFileUploaderInput,
  InnerPageToggleButton,
  InputLabel,
  InputSelect,
  NumberInput,
  SwitchInput,
  TextAreaInput,
  TextInput,
  TinyMCEInput,
  UploadImgeInput,
  UploadMedia,
} from '@wajeez-web/components/ui';
import { useAuthSelector } from '@wajeez-web/stores/auth';
import { convertHtmlToMarkdown } from '@wajeez-web/core/utils';
// import {
//   ContentSelector,
//   ContentEntityNarratorAudiosOutput,
//   ContentEntityTextsOutput,
//   SelectFactors,
//   SelectFactor,
//   ContentSorterOutput,
//   SortDirection,
//   SorterFactors,
// } from "../../constants/types/contentSystemTypes/contentItemsTypes";
// import { ContentItemTypeBasicInfoFields } from "../../constants/createContentItemsconstants";
// import { useAppSelector } from "../../redux/hooks";
// import useEffectCancelled from "../HelperComponents/useEffectCancelled";
// import CallBackSelectoreWithOptions from "../Inputs/CallBackSelectoreWithGetOptions";

const selectoreInitState = {
  factor: undefined,
  defaultCritiria: null,
  defaultEntityId: null,
  defaultTypeId: null,
  defaultRelationLength: null,
};

const sortersInitState = {
  factor: undefined,
  direction: undefined,
};

const narratorAudiosInitState = {
  narratorId: undefined,
  audioReference: undefined,
  isDefault: false,
};

const textsInitState = {
  text: '',
  isDefault: true,
};
export interface Row {
  id: number;
  order?: number;
  label?: string;
  name: string;
  permission?: string;
  value?: string | { label: string; value: string } | boolean;
  options?: { label: string; value: string }[];
  fieldType: Content.FieldType;
  onChange?: (props: any) => void;
  fieldOptions: {
    isMulti?: boolean; // with select input | CallbackSelect
    withOrder?: boolean; // with select input | CallbackSelect
    optionsListEndPoint?: string | null; // with CallbackSelect
    optionValueName?: string; // with CallbackSelect
    uploadEndPoint?: string | null; // with dragfiles | uploadImg | uploadFile
    upToKB?: number; // means file size  and came with  dragfiles
    types?: string[]; // file types to upload
    max?: number | null; // with number input
    min?: number | null;
    height?: number;
    maxLength?: number | null; // with text input
    minLength?: number | null; // with text input
    typeId?: number | null; // with select input
    prefix?: string;
    allowedPredefinedComponents?: string[];
    selectOptions?: { label: string; value: string }[];
    rows?: number;
    minDate?: string | undefined;
    maxDate?: string | undefined;
  };
  span?: number;
  disabled?: boolean;
  required?: boolean;
  placeHolder?: string;
}

export interface FormBuilderProps {
  title?: string;
  desc?: string;
  formValues?: { id: number; key: string; value: any }[];
  action?: (props: any) => void;
  rows: Row[];
  hasSubmitButton?: boolean;
  withoutCard?: boolean;
  getData?: (values: any) => void;
  submited?: boolean;
  hasValues?: boolean;
  // extraFeildsFormValues?: ExtraFieldsValuesProps;
  // extraFields?: ContentItemExtraFieldsKeys[];
  // requiredFeilds?: ContentItemRequierdKeys[];
  id?: string;
  getvaluesObj?: { url: string; method: 'post' | 'get' };
  hasToggelButton?: boolean;
  defaultNarratorId?: number;
}

const FormBuilder = ({
  title,
  desc,
  hasSubmitButton,
  formValues,
  action,
  rows,
  withoutCard,
  // extraFeildsFormValues,
  getData,
  submited,
  hasValues,
  getvaluesObj,
  id,
  defaultNarratorId,
  hasToggelButton,
}: // extraFields = [],
// requiredFeilds = [],
FormBuilderProps) => {
  const navigate = useNavigate();
  const permissions = useAuthSelector((s) => s.auth.permission ?? []);
  // const { contentEntityTypes } = useAppSelector(
  //   (state) => state.contentEntityTypes
  // );
  const { t } = useTranslation();
  // const [contentEntityTypeswithfields, setContentEntityTypeswithfields] =
  //   useState<ContentEntityTypesOutput[]>([]);
  // const { components } = useAppSelector((state) => state.components);
  const [values, setValues] = useState<any>({});
  // const [extraFieldsValues, setExtraFieldsValues] = useState<{
  //   selectors: ContentSelector[];
  //   sorters: ContentSorterOutput[];
  //   narratorAudios: ContentEntityNarratorAudiosOutput[];
  //   texts: ContentEntityTextsOutput[];
  // }>({
  //   narratorAudios: [
  //     {
  //       isDefault: true,
  //       narratorId: undefined,
  //     },
  //   ],
  //   selectors: [],
  //   sorters: [],
  //   texts: [
  //     {
  //       isDefault: true,
  //       text: "",
  //     },
  //   ],
  // });
  const [narrators, setNarrators] = useState<
    { label: string; value: string }[]
  >([]);

  useEffectCancelled((canceller: AbortController) => {
    // if (rows.find((item) => item.fieldType === FieldType.MappedField)) {
    //   ContentEntityTypeServices.getAllContentEntityTypes(
    //     null,
    //     "",
    //     1,
    //     1000,
    //     canceller
    //   ).then((res) => {
    //     setContentEntityTypeswithfields(res?.data);
    //   });
    // }
  }, []);

  // useEffect(() => {
  //   if (extraFields.includes(ContentItemExtraFieldsKeys.NarratorAudios)) {
  //     NarratorsServices.getAllNarrators(1, 10000).then((narrators) => {
  //       setNarrators(
  //         narrators.data.map((narrator: { name: string; id: number }) => ({
  //           label: narrator.name,
  //           value: narrator.id.toString(),
  //         }))
  //       );
  //     });
  //   }
  // }, [extraFields]);

  const getSumbitedValues = () => {
    // let fields = formsMetadata.createContentItemRequiredFeilds.fields
    //   .filter((item: any) => requiredFeilds.includes(item.name))
    //   .concat(rows);
    const fields = rows;
    const vals = { ...values };

    // const requiredFeildsVals: { [key: string]: any } = {};
    Object.keys(vals).forEach((key: any) => {
      // if (requiredFeilds.includes(key)) {
      //   requiredFeildsVals[key] = vals[key];
      //   delete vals[key];
      // }
      if (
        fields.find((item: Row) => item.name === key)?.fieldType ===
        Content.FieldType.TineMCE
      ) {
        vals[key] = vals[key] ? convertHtmlToMarkdown(vals[key]) : '';
      }
    });

    return { values: vals };
    // return { values: vals, ...requiredFeildsVals, ...extraFieldsValues };
  };
  useEffectCancelled(
    (abortController) => {
      if (submited === true) {
        getData && getData(getSumbitedValues());
      }
      return () => {
        abortController.abort();
      };
    },
    [submited]
  );

  useEffect(() => {
    const getVals = () => {
      const vals: any = {};
      //   const withRequiredFeildsRows = rows.concat(
      //     formsMetadata.createContentItemRequiredFeilds.fields.filter(
      //       (item: any) => requiredFeilds.includes(item.name)
      //     )
      //   );
      //   if (hasValues) {
      //     getvaluesObj &&
      //       FormBuilderServices.getFormData({
      //         url: getvaluesObj.url.replace(':id', id || ''),
      //         method: getvaluesObj.method,
      //       }).then((res) => {
      //         withRequiredFeildsRows.forEach((item, i) => {
      //           vals[item.name] = res[item.name];

      //           if (i === withRequiredFeildsRows.length - 1) {
      //             setValues(vals);
      //           }
      //         });
      //       });
      //   } else if (formValues?.length) {
      //     formValues.forEach((item, i) => {
      //       let type = rows.find((ele) => ele.name === item.key)?.fieldType;

      //       vals[item.key] =
      //         type === FieldType.Number
      //           ? Number(item.value) || Number(values[item.key])
      //           : item.value || values[item.key];
      //     });
      //     setValues(vals);
      //   } else
      //     withRequiredFeildsRows.forEach((item, i) => {
      //       vals[item.name] =
      //         item.fieldType === FieldType.Number
      //           ? 0
      //           : item.fieldType === FieldType.Switch
      //           ? false
      //           : item.fieldType === FieldType.Select
      //           ? null
      //           : item.fieldType === FieldType.MappedField
      //           ? []
      //           : undefined;

      //       if (i === withRequiredFeildsRows.length - 1) {
      //         setValues(vals);
      //       }
      //     });
    };
    getVals();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formValues]);

  //   useEffect(() => {
  //     if (extraFeildsFormValues) {
  //       setExtraFieldsValues(
  //         extraFeildsFormValues['narratorAudios'] &&
  //           extraFeildsFormValues.narratorAudios.length < 1
  //           ? {
  //               ...extraFeildsFormValues,
  //               narratorAudios: [
  //                 {
  //                   isDefault: true,
  //                   audioReference: undefined,
  //                   narratorId: undefined,
  //                 },
  //               ],
  //             }
  //           : extraFeildsFormValues
  //       );
  //     }
  //   }, [extraFeildsFormValues]);

  const onChange = (name: string, value: any) => {
    setValues({ ...values, [name]: value });
  };

  //   const extraFieldsChange = (
  //     keyName: string,
  //     value: any,
  //     i: number,
  //     extraFeildName:
  //       | ContentItemExtraFieldsKeys.Selectors
  //       | ContentItemExtraFieldsKeys.Sorters
  //       | ContentItemExtraFieldsKeys.NarratorAudios
  //       | ContentItemExtraFieldsKeys.Texts,
  //     type?: string
  //   ) => {
  //     if (
  //       extraFeildName == ContentItemExtraFieldsKeys.NarratorAudios &&
  //       keyName == 'isDefault'
  //     ) {
  //       extraFieldsValues[ContentItemExtraFieldsKeys.NarratorAudios] =
  //         extraFieldsValues[ContentItemExtraFieldsKeys.NarratorAudios].map(
  //           (d) => ({ ...d, isDefault: false })
  //         );
  //     }

  //     const array = extraFieldsValues[extraFeildName];
  //     if (type === 'select') {
  //       extraFieldsValues[extraFeildName][i] = {
  //         ...extraFieldsValues[extraFeildName][i],
  //         [keyName]: Number(value.value),
  //       };
  //     } else
  //       extraFieldsValues[extraFeildName][i] = {
  //         ...extraFieldsValues[extraFeildName][i],
  //         [keyName]: value,
  //       };

  //     setExtraFieldsValues({
  //       ...extraFieldsValues,
  //       [extraFeildName]: [...array],
  //     });
  //   };

  const handleSelectInputValue = (name: string, value: any) => {
    value &&
      (Array.isArray(value)
        ? onChange(
            name,
            value.map((item: any) => item.value)
          )
        : onChange(name, value.value));
  };

  const getInput = ({
    label,
    name,
    required,
    options,
    fieldType,
    fieldOptions,
    placeHolder,
    permission,
  }: Row) => {
    switch (fieldType) {
      case Content.FieldType.MappedField:
        return (
          <>
            <InputLabel text={label} name={name} required={required} />

            <Select
              isMulti={true}
              isDisabled={
                permission && !permissions.includes(permission) ? true : false
              }
              name={name}
              //   value={
              //     contentEntityTypeswithfields?.length &&
              //     values[name] &&
              //     values[name]?.length > 0 &&
              //     values[name]
              //       ?.map((element: any) =>
              //         contentEntityTypeswithfields
              //           ?.find((item) =>
              //             item.fields.find((ele) => ele.id === element)
              //           )
              //           ?.fields.find((item) => item.id === element)
              //       )
              //       ?.map((ele: any) => ({ label: ele.label, value: ele.id }))
              //   }
              //   options={contentEntityTypeswithfields?.map((item: any) => ({
              //     label: item.name,
              //     options: item.fields.map((ele: any) => ({
              //       label: ele.label,
              //       value: ele.id,
              //     })),
              //   }))}
              placeholder={placeHolder}
              onChange={(value) => {
                handleSelectInputValue(name, value);
              }}
            />
          </>
        );
      case Content.FieldType.PredefinedComponent:
        return (
          <InputSelect
            disabled={
              permission && !permissions.includes(permission) ? true : false
            }
            placeholder={placeHolder}
            required={required}
            label={label}
            name={name}
            value={{ label: values[name], value: values[name] }}
            options={
              fieldOptions.allowedPredefinedComponents?.map((item) => ({
                label: item,
                value: item,
              })) || []
            }
            onChange={handleSelectInputValue}
          />
        );
      case Content.FieldType.RequiredComponent:
        return (
          <InputSelect
            disabled={
              permission && !permissions.includes(permission) ? true : false
            }
            required={required}
            label={label}
            name={name}
            placeholder={placeHolder}
            // value={
            //   components
            //     .filter(
            //       (item) =>
            //         item.typeId.toString() === fieldOptions.typeId?.toString()
            //     )
            //     ?.map((item) => ({
            //       label: item.referenceName,
            //       value: item.id,
            //     }))
            //     .find(
            //       (item: { value: string }) => item.value === values[name]
            //     ) || undefined
            // }
            // options={components
            //   ?.filter((item) => item.typeId === fieldOptions.typeId)
            //   .map((item) => ({
            //     label: item.referenceName,
            //     value: item.id,
            //   }))}
            options={[]}
            onChange={handleSelectInputValue}
          />
        );
      case Content.FieldType.UploadFile:
        return (
          <UploadMedia
            disabled={
              permission && !permissions.includes(permission) ? true : false
            }
            value={values[name] || ''}
            placeholder={placeHolder}
            label={label}
            name={name || ''}
            fileTypes={fieldOptions.types || []}
            required={required}
            onChange={onChange}
          />
        );
      case Content.FieldType.CallbackSelect:
        return (
          <CallBackSelector
            disabled={
              permission && !permissions.includes(permission) ? true : false
            }
            required={required}
            prefix={fieldOptions.prefix || ''}
            isMulti={fieldOptions.isMulti}
            value={values[name] || undefined}
            label={label}
            name={name || ''}
            placeholder={placeHolder}
            onChange={onChange}
          />
        );
      //   case Content.FieldType.CallbackSelect:
      //     return (
      //       <CallBackSelectorWithOptions
      //           disabled={
      //   permission && !permissions.includes(permission) ? true : false
      // }
      //         required={required}
      //         prefix={fieldOptions.prefix || ''}
      //         isMulti={fieldOptions.isMulti}
      //         // @ts-ignore
      //         getOptions={fieldOptions.optionsListEndPiont}
      //         value={values[name] || undefined}
      //         label={label}
      //         name={name || ''}
      //         placeholder={placeHolder}
      //         onChange={onChange}
      //       />
      //     );
      case Content.FieldType.TineMCE:
        return (
          <TinyMCEInput
            disabled={
              permission && !permissions.includes(permission) ? true : false
            }
            required={required}
            value={values[name] || ''}
            label={label}
            name={name || ''}
            placeholder={placeHolder}
            onChange={onChange}
          />
        );
      case Content.FieldType.UploadImage:
        return (
          <UploadImgeInput
            disabled={
              permission && !permissions.includes(permission) ? true : false
            }
            required={required}
            value={values[name] || ''}
            label={label}
            name={name}
            action={onChange}
          />
        );
      case Content.FieldType.Switch:
        return (
          <SwitchInput
            required={required}
            value={values[name] || ''}
            placeholder={placeHolder}
            label={label}
            name={name || ''}
            disabled={
              permission && !permissions.includes(permission) ? true : false
            }
            onChange={onChange}
          />
        );
      case Content.FieldType.Number:
        return (
          <NumberInput
            disabled={
              permission && !permissions.includes(permission) ? true : false
            }
            required={required}
            value={values[name] || 0}
            placeholder={placeHolder}
            max={fieldOptions?.max || undefined}
            min={fieldOptions?.min || undefined}
            label={label}
            name={name || ''}
            onChange={onChange}
          />
        );
      case Content.FieldType.Select:
        return (
          <InputSelect
            disabled={
              permission && !permissions.includes(permission) ? true : false
            }
            required={required}
            value={
              ((values[name] || values[name] == 0) &&
                (Array.isArray(values[name])
                  ? fieldOptions.selectOptions?.filter((item) => {
                      return values[name].includes(item.value);
                    })
                  : fieldOptions.selectOptions?.find((item) => {
                      return item.value.toString() === values[name].toString();
                    }))) ||
              undefined
            }
            placeholder={placeHolder}
            isMulti={fieldOptions?.isMulti}
            options={options || fieldOptions.selectOptions || []}
            label={label}
            name={name || ''}
            onChange={handleSelectInputValue}
          />
        );
      case Content.FieldType.DragFile:
        return (
          <DragAndDropFileUploaderInput
            disabled={
              permission && !permissions.includes(permission) ? true : false
            }
            required={required}
            placeholder={placeHolder}
            upTo={fieldOptions?.upToKB || undefined}
            types={fieldOptions?.types}
            label={label}
            name={name || ''}
            onChange={onChange}
          />
        );
      case Content.FieldType.Date:
        return (
          <DatePickerInput
            disabled={
              permission && !permissions.includes(permission) ? true : false
            }
            required={required}
            value={values[name] || null}
            placeholder={placeHolder}
            showTime={false}
            label={label}
            name={name || ''}
            onChange={onChange}
          />
        );
      case Content.FieldType.DateTime:
        return (
          <DatePickerInput
            disabled={
              permission && !permissions.includes(permission) ? true : false
            }
            required={required}
            value={values[name] || null}
            placeholder={placeHolder}
            showTime={true}
            label={label}
            name={name || ''}
            onChange={onChange}
          />
        );
      case Content.FieldType.AreaText:
        return (
          <TextAreaInput
            disabled={
              permission && !permissions.includes(permission) ? true : false
            }
            required={required}
            value={values[name] || ''}
            placeholder={placeHolder}
            label={label}
            name={name || ''}
            onChange={onChange}
          />
        );
      case Content.FieldType.Text:
        return (
          <TextInput
            disabled={
              permission && !permissions.includes(permission) ? true : false
            }
            required={required}
            value={values[name] ? values[name] : ''}
            placeholder={placeHolder}
            label={label}
            name={name || ''}
            onChange={onChange}
          />
        );
      case Content.FieldType.ColorPicker:
        return (
          <ColorPickerInput
            disabled={
              permission && !permissions.includes(permission) ? true : false
            }
            required={required}
            value={values[name] ? values[name] : ''}
            placeholder={placeHolder}
            label={label}
            name={name || ''}
            onChange={onChange}
          />
        );

      default:
        return null;
    }
  };

  //   const deleteExtraFeildAction = (
  //     extraFeildName:
  //       | ContentItemExtraFieldsKeys.Selectors
  //       | ContentItemExtraFieldsKeys.Sorters
  //       | ContentItemExtraFieldsKeys.NarratorAudios
  //       | ContentItemExtraFieldsKeys.Texts,

  //     i: number
  //   ) => {
  //     const array = extraFieldsValues[extraFeildName];
  //     array.splice(i, 1);
  //     setExtraFieldsValues({
  //       ...extraFieldsValues,
  //       [extraFeildName]: [...array],
  //     });
  //   };

  //   const getExtraFields = (type: ContentItemExtraFieldsKeys) => {
  //     switch (type) {
  //       case ContentItemExtraFieldsKeys.Selectors:
  //         return (
  //           <div className="mt-6">
  //             <div className="flex space-s-2 ">
  //               <InputLabel text="Selectors" name="selectors" />
  //               <Button
  //                 shape={'circle'}
  //                 bg="ring-color"
  //                 color="textPrimary"
  //                 type={'text'}
  //                 Icon={PlusIcon}
  //                 onClick={() => {
  //                   setExtraFieldsValues({
  //                     ...extraFieldsValues,
  //                     selectors: [
  //                       selectoreInitState,
  //                       ...extraFieldsValues.selectors,
  //                     ],
  //                   });
  //                 }}
  //               />
  //             </div>

  //             <div className="space-y-6">
  //               {extraFieldsValues?.selectors?.map((item, key) => (
  //                 <Card key={key}>
  //                   <div className="space-y-1">
  //                     <div className="flex justify-end">
  //                       {' '}
  //                       <Button
  //                         Icon={TrashIcon}
  //                         color="red-500 "
  //                         bg="white"
  //                         type="text"
  //                         onClick={() => {
  //                           deleteExtraFeildAction(
  //                             ContentItemExtraFieldsKeys.Selectors,
  //                             key
  //                           );
  //                         }}
  //                       />
  //                     </div>
  //                     <div className={`grid grid-cols-${4} gap-3 `}>
  //                       <div className={`md:col-span-${2} col-span-${2}`}>
  //                         <InputSelect
  //                           value={
  //                             item.factor && {
  //                               label:
  //                                 SelectFactors.find(
  //                                   (ele) => ele.id === item.factor
  //                                 )?.name || '',
  //                               value:
  //                                 SelectFactors.find(
  //                                   (ele) => ele.id === item.factor
  //                                 )?.id.toString() || '',
  //                             }
  //                           }
  //                           label="Select Factore"
  //                           required={true}
  //                           name="factor"
  //                           onChange={(name, value) => {
  //                             extraFieldsChange(
  //                               name,
  //                               value,
  //                               key,
  //                               ContentItemExtraFieldsKeys.Selectors,
  //                               'select'
  //                             );
  //                           }}
  //                           options={SelectFactors.map((item) => ({
  //                             label: item.name,
  //                             value: item.id.toString(),
  //                           }))}
  //                         />
  //                       </div>
  //                       <div className={`md:col-span-${2} col-span-${2}`}></div>
  //                       {item.factor &&
  //                         getSelecterComponents(item.factor, key)?.map(
  //                           (ele, i) => (
  //                             <div
  //                               key={i}
  //                               className={`md:col-span-${2} col-span-${2}`}
  //                             >
  //                               {ele}
  //                             </div>
  //                           )
  //                         )}
  //                     </div>{' '}
  //                   </div>
  //                 </Card>
  //               ))}
  //             </div>
  //           </div>
  //         );
  //       case ContentItemExtraFieldsKeys.Sorters:
  //         return (
  //           <div className="mt-6">
  //             <div className="flex space-s-2">
  //               <InputLabel text="Sorters" name="sorters" />
  //               <Button
  //                 bg="ring-color"
  //                 color="textPrimary"
  //                 shape={'circle'}
  //                 type={'text'}
  //                 Icon={PlusIcon}
  //                 onClick={() => {
  //                   setExtraFieldsValues({
  //                     ...extraFieldsValues,
  //                     sorters: [sortersInitState, ...extraFieldsValues.sorters],
  //                   });
  //                 }}
  //               />
  //             </div>

  //             <div className="space-y-6">
  //               {extraFieldsValues?.sorters?.map((item, key) => (
  //                 <Card key={key}>
  //                   <div className="space-y-1">
  //                     <div className="flex justify-end">
  //                       {' '}
  //                       <Button
  //                         Icon={TrashIcon}
  //                         color="red-500 "
  //                         type="text"
  //                         onClick={() => {
  //                           deleteExtraFeildAction(
  //                             ContentItemExtraFieldsKeys.Sorters,
  //                             key
  //                           );
  //                         }}
  //                       />
  //                     </div>
  //                     <div className={`grid grid-cols-${4} gap-3 `}>
  //                       <div className={`md:col-span-${2} col-span-${2}`}>
  //                         <InputSelect
  //                           value={
  //                             item.factor && {
  //                               label:
  //                                 SorterFactors.find(
  //                                   (ele) => ele.id === item.factor
  //                                 )?.name || '',
  //                               value:
  //                                 SorterFactors.find(
  //                                   (ele) => ele.id === item.factor
  //                                 )?.id.toString() || '',
  //                             }
  //                           }
  //                           label="Sort Factore"
  //                           required={true}
  //                           name="factor"
  //                           onChange={(name, value) => {
  //                             extraFieldsChange(
  //                               name,
  //                               value,
  //                               key,
  //                               ContentItemExtraFieldsKeys.Sorters,
  //                               'select'
  //                             );
  //                           }}
  //                           options={SorterFactors.map((item) => ({
  //                             label: item.name,
  //                             value: item.id.toString(),
  //                           }))}
  //                         />
  //                       </div>
  //                       <div className={`md:col-span-${2} col-span-${2}`}>
  //                         <InputSelect
  //                           value={
  //                             (item.direction === 0 || item.direction) && {
  //                               label:
  //                                 SortDirection.find(
  //                                   (ele) => ele.id === item.direction
  //                                 )?.name || '',
  //                               value:
  //                                 SortDirection.find(
  //                                   (ele) => ele.id === item.direction
  //                                 )?.id.toString() || '',
  //                             }
  //                           }
  //                           label="Direction"
  //                           required={true}
  //                           name="direction"
  //                           onChange={(name, value) => {
  //                             extraFieldsChange(
  //                               name,
  //                               value,
  //                               key,
  //                               ContentItemExtraFieldsKeys.Sorters,
  //                               'select'
  //                             );
  //                           }}
  //                           options={SortDirection.map((item) => ({
  //                             label: item.name,
  //                             value: item.id.toString(),
  //                           }))}
  //                         />
  //                       </div>
  //                     </div>{' '}
  //                   </div>
  //                 </Card>
  //               ))}
  //             </div>
  //           </div>
  //         );
  //       case ContentItemExtraFieldsKeys.NarratorAudios:
  //         return (
  //           <div className="mt-6">
  //             <div className="flex space-s-2">
  //               <InputLabel required={true} text="Audios" name="audios" />
  //               <Button
  //                 bg="ring-color"
  //                 shape={'circle'}
  //                 type={'text'}
  //                 color="text-textPrimary"
  //                 Icon={PlusIcon}
  //                 onClick={() => {
  //                   setExtraFieldsValues({
  //                     ...extraFieldsValues,
  //                     narratorAudios: [
  //                       {
  //                         ...narratorAudiosInitState,
  //                         narratorId: defaultNarratorId || undefined,
  //                         isDefault:
  //                           extraFieldsValues.narratorAudios.length >= 1
  //                             ? false
  //                             : true,
  //                       },
  //                       ...extraFieldsValues.narratorAudios,
  //                     ],
  //                   });
  //                 }}
  //               />
  //             </div>

  //             <div className="space-y-6">
  //               {extraFieldsValues?.narratorAudios?.map((item, key) => (
  //                 <Card key={`${key} ${item.contentEntityAudioId}`}>
  //                   <div className="space-y-1">
  //                     <div className="flex justify-end">
  //                       {' '}
  //                       <Button
  //                         Icon={TrashIcon}
  //                         color="red-500 "
  //                         type="text"
  //                         onClick={() => {
  //                           deleteExtraFeildAction(
  //                             ContentItemExtraFieldsKeys.NarratorAudios,
  //                             key
  //                           );
  //                         }}
  //                       />
  //                     </div>
  //                     <div className={`grid grid-cols-${1} gap-3 `}>
  //                       <div className={`md:col-span-${4} col-span-${4}`}>
  //                         <InputSelect
  //                           value={narrators.find(
  //                             (ele) => ele.value === item.narratorId?.toString()
  //                           )}
  //                           label="Narrator"
  //                           required={true}
  //                           name="narratorId"
  //                           onChange={(name, value) => {
  //                             extraFieldsChange(
  //                               name,
  //                               value,
  //                               key,
  //                               ContentItemExtraFieldsKeys.NarratorAudios,
  //                               'select'
  //                             );
  //                           }}
  //                           options={narrators}
  //                         />
  //                       </div>
  //                       <div className={`md:col-span-${4} col-span-${4}`}>
  //                         <UploadMedia
  //                           value={
  //                             extraFieldsValues.narratorAudios[key]
  //                               .audioReference || ''
  //                           }
  //                           label="Audio"
  //                           fileTypes={['audio/*']}
  //                           required={true}
  //                           name="audioReference"
  //                           onChange={(name: string, value: string) => {
  //                             extraFieldsChange(
  //                               name,
  //                               value,
  //                               key,
  //                               ContentItemExtraFieldsKeys.NarratorAudios
  //                             );
  //                           }}
  //                         />
  //                       </div>
  //                       <div className={`md:col-span-${4} col-span-${4}`}>
  //                         <SwitchInput
  //                           value={
  //                             extraFieldsValues.narratorAudios[key].isDefault
  //                           }
  //                           label="is Default"
  //                           required={false}
  //                           placeholder="Make This audio as default"
  //                           name="isDefault"
  //                           onChange={(name, value) => {
  //                             extraFieldsChange(
  //                               name,
  //                               value,
  //                               key,
  //                               ContentItemExtraFieldsKeys.NarratorAudios
  //                             );
  //                           }}
  //                         />
  //                       </div>
  //                     </div>{' '}
  //                   </div>
  //                 </Card>
  //               ))}
  //             </div>
  //           </div>
  //         );
  //       case ContentItemExtraFieldsKeys.Audio:
  //         return (
  //           <div className="mt-6">
  //             <div className="flex space-s-2">
  //               <InputLabel required={true} text="Audios" name="audios" />
  //               <Button
  //                 bg="ring-color"
  //                 shape={'circle'}
  //                 type={'text'}
  //                 color="text-textPrimary"
  //                 Icon={PlusIcon}
  //                 onClick={() => {
  //                   setExtraFieldsValues({
  //                     ...extraFieldsValues,
  //                     narratorAudios: [
  //                       {
  //                         ...narratorAudiosInitState,
  //                         narratorId: undefined,
  //                       },
  //                       ...extraFieldsValues.narratorAudios,
  //                     ],
  //                   });
  //                 }}
  //               />
  //             </div>

  //             <div className="space-y-6">
  //               {extraFieldsValues.narratorAudios.map((item, key) => (
  //                 <Card key={`${key} ${item.contentEntityAudioId}`}>
  //                   <div className="space-y-1">
  //                     <div className="flex justify-end">
  //                       {' '}
  //                       <Button
  //                         Icon={TrashIcon}
  //                         color="red-500 "
  //                         type="text"
  //                         onClick={() => {
  //                           deleteExtraFeildAction(
  //                             ContentItemExtraFieldsKeys.NarratorAudios,
  //                             key
  //                           );
  //                         }}
  //                       />
  //                     </div>
  //                     <div className={`grid grid-cols-${1} gap-3 `}>
  //                       {/* <div className={`md:col-span-${4} col-span-${4}`}>
  //                         <InputSelect
  //                           value={narrators.find(
  //                             (ele) => ele.value === item.narratorId?.toString()
  //                           )}
  //                           label="Narrator"
  //                           required={true}
  //                           name="narratorId"
  //                           onChange={(name, value) => {
  //                             extraFieldsChange(
  //                               name,
  //                               value,
  //                               key,
  //                               ContentItemExtraFieldsKeys.NarratorAudios,
  //                               "select"
  //                             );
  //                           }}
  //                           options={narrators}
  //                         />
  //                       </div> */}
  //                       <div className={`md:col-span-${4} col-span-${4}`}>
  //                         <UploadMedia
  //                           value={
  //                             extraFieldsValues.narratorAudios[key]
  //                               .audioReference || ''
  //                           }
  //                           label="Audio"
  //                           fileTypes={['audio/*']}
  //                           required={true}
  //                           name="audioReference"
  //                           onChange={(name: string, value: string) => {
  //                             extraFieldsChange(
  //                               name,
  //                               value,
  //                               key,
  //                               ContentItemExtraFieldsKeys.NarratorAudios
  //                             );
  //                           }}
  //                         />
  //                       </div>
  //                       <div className={`md:col-span-${4} col-span-${4}`}>
  //                         <SwitchInput
  //                           value={
  //                             extraFieldsValues.narratorAudios[key].isDefault
  //                           }
  //                           label="is Default"
  //                           required={false}
  //                           placeholder="Make This audio as default"
  //                           name="isDefault"
  //                           onChange={(name, value) => {
  //                             extraFieldsChange(
  //                               name,
  //                               value,
  //                               key,
  //                               ContentItemExtraFieldsKeys.NarratorAudios
  //                             );
  //                           }}
  //                         />
  //                       </div>
  //                     </div>{' '}
  //                   </div>
  //                 </Card>
  //               ))}
  //             </div>
  //           </div>
  //         );
  //       case ContentItemExtraFieldsKeys.Texts:
  //         return (
  //           <div className="mt-6 border-t space-y-2 ">
  //             <div className="flex space-s-2 mt-2">
  //               <InputLabel text="Texts" name="texts" />
  //               {extraFieldsValues.texts.length === 0 && (
  //                 <Button
  //                   bg="ring-color"
  //                   shape={'circle'}
  //                   type={'text'}
  //                   color={'text-textPrimary'}
  //                   Icon={PlusIcon}
  //                   onClick={() => {
  //                     setExtraFieldsValues({
  //                       ...extraFieldsValues,
  //                       texts: [textsInitState, ...extraFieldsValues.texts],
  //                     });
  //                   }}
  //                 />
  //               )}
  //             </div>

  //             <div className="space-y-6">
  //               {extraFieldsValues.texts.map((item, key) => (
  //                 <Card key={key}>
  //                   <div className="space-y-1">
  //                     <div className="flex justify-end">
  //                       {' '}
  //                       <Button
  //                         Icon={TrashIcon}
  //                         color="red-500 "
  //                         type="text"
  //                         onClick={() => {
  //                           deleteExtraFeildAction(
  //                             ContentItemExtraFieldsKeys.Texts,
  //                             key
  //                           );
  //                         }}
  //                       />
  //                     </div>
  //                     <div className={`grid grid-cols-${1} gap-3 `}>
  //                       <div className={`md:col-span-${4} col-span-${4}`}>
  //                         <TinyMCEInput
  //                           value={extraFieldsValues.texts[key].text}
  //                           label="Text"
  //                           required={true}
  //                           name="text"
  //                           onChange={(name, value) => {
  //                             extraFieldsChange(
  //                               name,
  //                               value,
  //                               key,
  //                               ContentItemExtraFieldsKeys.Texts
  //                             );
  //                           }}
  //                         />
  //                       </div>

  //                       {/* <div className={`md:col-span-${4} col-span-${4}`}>
  //                         <SwitchInput
  //                           value={extraFieldsValues.texts[key].isDefault}
  //                           label="is Default"
  //                           required={false}
  //                           placeholder="Make This text as default"
  //                           name="isDefault"
  //                           onChange={(name, value) => {
  //                             extraFieldsChange(
  //                               name,
  //                               value,
  //                               key,
  //                               ContentItemExtraFieldsKeys.Texts
  //                             );
  //                           }}
  //                         />
  //                       </div> */}
  //                     </div>{' '}
  //                   </div>
  //                 </Card>
  //               ))}
  //             </div>
  //           </div>
  //         );
  //     }
  //   };

  const getFormRows = () => {
    return (
      <div className="space-y-8">
        {title && (
          <div className="">
            <h3 className="ms-2 lg:ms-0 text-2xl flex align-middle font-bold space-s-2 tracking-tight leading-none  ">
              {hasToggelButton && <InnerPageToggleButton />}{' '}
              <div className="mt-1">{title}</div>
            </h3>
            <p className=" text-sm text-gray-600">{desc}</p>
          </div>
        )}
        <div>
          <div className="space-y-6">
            <div className={`grid grid-cols-${3} gap-3 `}>
              {' '}
              {rows.map((item: Row, i: number) => {
                return (
                  <div
                    key={item.name + i}
                    tabIndex={i}
                    className={`md:col-span-${3} col-span-${3} `}
                  >
                    {getInput(item)}
                    {/* {item.name === ContentItemRequierdKeys.ItemTemplate ? (
                        <SetItemTemplateSelectField
                          item={item}
                          onChange={handleSelectInputValue}
                          itemTemplateId={values[item.name]}
                        />
                      ) : (
                        getInput(item)
                      )} */}
                  </div>
                );
              })}
              {/* {formsMetadata.createContentItemRequiredFeilds.fields
                .filter((item: any) => requiredFeilds.includes(item.name))
                .concat(rows)
                .map((item: Row, i: number) => {
                  return (
                    <div
                      key={item.name + i}
                      tabIndex={i}
                      className={`md:col-span-${3} col-span-${3} `}
                    >
                      {item.name === ContentItemRequierdKeys.ItemTemplate ? (
                        <SetItemTemplateSelectField
                          item={item}
                          onChange={handleSelectInputValue}
                          itemTemplateId={values[item.name]}
                        />
                      ) : (
                        getInput(item)
                      )}
                    </div>
                  );
                })} */}
            </div>
          </div>
          {/* {extraFields.map((item) => (
            <div key={item}>{getExtraFields(item)}</div>
          ))} */}
        </div>
      </div>
    );
  };

  //   const getSelecterComponents = (selectFactore: SelectFactor, i: number) => {
  //     const selectoreFeilds: {
  //       name: 'criteria' | 'entityId' | 'type' | 'relationLength';
  //       component: JSX.Element;
  //     }[] = [
  //       {
  //         name: 'criteria',
  //         component: (
  //           <TextInput
  //             label="Default Critiria"
  //             onChange={(name, value) =>
  //               extraFieldsChange(
  //                 name,
  //                 value,
  //                 i,
  //                 ContentItemExtraFieldsKeys.Selectors
  //               )
  //             }
  //             name="defaultCritiria"
  //             value={extraFieldsValues.selectors[i].defaultCritiria || ''}
  //           />
  //         ),
  //       },
  //       {
  //         name: 'entityId',
  //         component: (
  //           <TextInput
  //             label="Default Entity Id"
  //             onChange={(name, value) =>
  //               extraFieldsChange(
  //                 name,
  //                 value,
  //                 i,
  //                 ContentItemExtraFieldsKeys.Selectors
  //               )
  //             }
  //             name="defaultEntityId"
  //             value={extraFieldsValues.selectors[i].defaultEntityId || ''}
  //           />
  //         ),
  //       },
  //       {
  //         name: 'type',
  //         component: (
  //           <InputSelect
  //             label="Default Entity Type"
  //             onChange={(name, value) => {
  //               return extraFieldsChange(
  //                 name,
  //                 value,
  //                 i,
  //                 ContentItemExtraFieldsKeys.Selectors,
  //                 'select'
  //               );
  //             }}
  //             name="defaultTypeId"
  //             options={contentEntityTypes?.map((item) => ({
  //               label: item.name,
  //               value: item.id,
  //             }))}
  //             value={contentEntityTypes
  //               ?.map((item) => ({
  //                 label: item.name,
  //                 value: item.id,
  //               }))
  //               .find(
  //                 (ele: any) =>
  //                   ele.value === extraFieldsValues.selectors[i].defaultTypeId
  //               )}
  //           />
  //         ),
  //       },
  //       {
  //         name: 'relationLength',
  //         component: (
  //           <NumberInput
  //             label="Relation Length"
  //             onChange={(name, value) =>
  //               extraFieldsChange(
  //                 name,
  //                 value,
  //                 i,
  //                 ContentItemExtraFieldsKeys.Selectors
  //               )
  //             }
  //             name="defaultRelationLength"
  //             value={extraFieldsValues.selectors[i].defaultRelationLength || 0}
  //           />
  //         ),
  //       },
  //     ];

  //     const selctedFactorefeildsArgs = SelectFactors.find(
  //       (item) => item.id === selectFactore
  //     )?.arguments;
  //     return (
  //       selctedFactorefeildsArgs &&
  //       selectoreFeilds
  //         .filter((ele) => selctedFactorefeildsArgs[ele.name] === true)
  //         .map((item) => item.component)
  //     );
  //   };

  return withoutCard ? (
    <div className="space-y-6">
      {getFormRows()}
      {hasSubmitButton && (
        <div className="p-4 border-t flex justify-end rounded-md">
          <Button
            // refName={"create-book"}
            title="save"
            onClick={() => {
              action && action(getSumbitedValues());
            }}
            bg="primary"
            color="white"
          />
        </div>
      )}
    </div>
  ) : (
    <Card
      cardBottom={
        <div className="p-4 bg-gray-100 flex justify-end space-s-2 rounded-md">
          <Button
            // refName={"create-book"}
            title="Cancel"
            onClick={() => {
              Swal.fire({
                title: t(`general.${'Are you sure?'}`, '') as string,
                text: t(
                  `general.${"You won't be able to revert this!"}`,
                  ''
                ) as string,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: t(`general.${'Yes'}`, '') as string,
                cancelButtonText: t(`general.${'Cancel'}`, '') as string,
              }).then((result) => {
                if (result.isConfirmed) {
                  navigate(-1);
                }
              });
            }}
            bg="white"
            color="textPrimary"
          />
          <Button
            // refName={"create-book"}
            title="save"
            onClick={() => {
              action && action(getSumbitedValues());
            }}
            bg="primary"
            color="white"
          />
        </div>
      }
    >
      {getFormRows()}
    </Card>
  );
};

export default FormBuilder;
